export default {
    labels: {
        forgot_password: 'Forgot your password?',
        register: 'Register now',
        password: 'Password',
        confirm_password: 'Repeat password',
        login: 'Login',
        enter: 'Logging in ...',
        send_link: 'Sending a link ...',
        resend_link: 'Resend the link',
        search_user: 'Looking for a user ...',
    },

    buttons: {
        enter: 'Sign in',
        recovery_password: 'Restore password',
    }
}
